module.exports = __webpack_public_path__ + "img/9b00ca62621795a0a97e38565c8435b2.b7ef5631.png";